module.exports = __webpack_public_path__ + "img/he.1b7075cc.svg";